import {useEffect, useState} from 'react';
import {PrTimesLogo} from '@prtimes-basis/logos/pr-times-logo';
import styles from './responsive-header.module.css';
import {HamburgerMenu} from './hamburger-menu';
import {UserMenu} from './user-menu';
import {HeaderSearchIcon} from './header-search-icon';
import {Categories} from './categories';
import {SearchForm} from './search-form';
import {type PrtimesInformation} from './hamburger-menu/drawer-menu/prtimes-information-section';

type WithLoading<T> = {isLoading: true} | {isLoading: false; value: T};

type Props = {
  readonly myPagePath: WithLoading<string | undefined>;
  readonly showLoginModal: () => void;
  readonly popularKeywords:
    | Array<{
        kijinetaTagId: number;
        kijinetaTag: string;
      }>
    | undefined;
  readonly informationList?: PrtimesInformation[];
  readonly viewStyle: 'list' | 'title-only';
  readonly setViewStyle: (value: 'list' | 'title-only') => void;
};

export function ResponsiveHeader({
  myPagePath,
  showLoginModal,
  popularKeywords,
  informationList,
  viewStyle,
  setViewStyle,
}: Props) {
  const [view, setView] = useState<'default' | 'search' | 'navi'>('default');

  // ビューによって overflow を制御するための effect
  useEffect(() => {
    const overflow = view === 'default' ? 'visible' : 'hidden';
    document.body.style.overflow = overflow;
  }, [view]);

  const [isSearchFormExpanded, setIsSearchFormExpanded] = useState(false);

  return (
    <div className={styles.container}>
      <header className={styles.inner}>
        <div className={styles.top}>
          <div className={styles.topLeft}>
            <div className={styles.hamburger}>
              <HamburgerMenu
                view={view}
                setView={setView}
                viewStyle={viewStyle}
                setViewStyle={setViewStyle}
                informationList={informationList}
              />
            </div>

            <a
              className={styles.logoLink}
              href='/'
              aria-label='PR TIMESのトップページはこちら'
            >
              <PrTimesLogo variant='white' className={styles.logo} />
              <span className={styles.titleText}>
                プレスリリース・ニュースリリース配信サービスのPR TIMES
              </span>
            </a>
          </div>

          <nav className={styles.topRight}>
            <UserMenu
              myPagePath={myPagePath}
              showLoginModal={showLoginModal}
              isSearchFormExpanded={isSearchFormExpanded}
            />

            <div className={styles.sp}>
              <HeaderSearchIcon
                view={view}
                setView={setView}
                popularKeywords={popularKeywords}
              />
            </div>
            <div className={styles.pc}>
              <SearchForm
                isExpanded={isSearchFormExpanded}
                setIsExpanded={setIsSearchFormExpanded}
              />
            </div>
          </nav>
        </div>

        <div className={styles.pc}>
          <Categories
            openNaviMenu={() => {
              setView('navi');
            }}
          />
        </div>
      </header>
    </div>
  );
}
